import PropTypes from "prop-types"
import { MuiTelInput } from "mui-tel-input"
import { Controller } from "react-hook-form"

const PhoneNumber = ({ control, defaultCountry = "FR", label, name, required, ...rest }) => {

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <MuiTelInput
          {...field}
          {...rest}
          data-field={name}
          data-testid={`${name}-field`}
          defaultCountry={defaultCountry}
          disableDropdown
          error={!!error}
          fullWidth
          helperText={error ? error.message : null}
          id={name}
          inputProps={{
            ...(rest.inputProps || {}),
            'data-field': name,
            'data-testid': `${name}-input`,
            name,
          }}
          label={label}
          langOfCountryName="FR"
          MenuProps={{
            disablePortal: true,
            disableScrollLock: true,
          }}
          preferredCountries={["FR", "BE", "CH"]}
          required={required}
          size="small"
        />
      )}
    />
  )
}

PhoneNumber.propTypes = {
  control: PropTypes.object.isRequired,
  defaultCountry: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool
}

export default PhoneNumber
